import * as React from 'react';
import * as styled from './styled';
import {Wrapper} from '../../styled';
import {ClassificationGroupObject, TaskObject} from 'api/task/types';
import {useFormikContext} from 'formik';
import {Group} from './components/Group';
import {IconRoundPlus} from 'icons';
import {useBlockContext} from '../../../../hooks/useBlockContext';

/**
 * The classification content.
 * @return {React.ReactElement}
 * @constructor
 */
export default function Classification(): React.ReactElement {
  const {setFieldValue} = useFormikContext<Partial<TaskObject>>();
  const block = useBlockContext();

  // @ts-ignore
  const groups = block?.groups || [] as string[];

  /**
   * Render groups.
   * @return {JSX.Element}
   */
  function renderGroups(): JSX.Element {
    /**
     * Render push button.
     * @return {JSX.Element}
     */
    function renderPushButton(): JSX.Element {
      /**
       * The click event handler.
       * @return {void}
       */
      function handleClick(): void {
        setFieldValue(
          `content.blocks[${block.index}].groups`,
          [
            ...groups,
            {
              title: '',
              words: [],
            },
          ]
        );
      }

      return (
        <styled.PushButton type="button" onClick={handleClick}>
          <IconRoundPlus />
          Добавить группу
        </styled.PushButton>
      );
    }

    /**
     * Render group.
     * @param {ClassificationGroupObject} group
     * @param {number} index
     * @return {JSX.Element}
     */
    function renderGroup(
      group: ClassificationGroupObject,
      index: number,
    ): JSX.Element {
      return (
        <Group
          key={index}
          group={group}
          index={index}
        />
      );
    }

    return (
      <styled.Groups>
        {groups.map((group: ClassificationGroupObject, index: number) => (
          renderGroup(group, index)
        ))}
        {renderPushButton()}
      </styled.Groups>
    );
  }

  return (
    <Wrapper>
      {renderGroups()}
    </Wrapper>
  );
}
